import { Button, Result } from 'antd';
import { FC } from 'react';

interface ErrorPageProps {
  onClick?: () => void;
  title?: string;
  subTitle?: string;
}
const ErrorPage: FC<ErrorPageProps> = ({
  onClick,
  title = 'No se pudo conectar al servidor',
  subTitle = 'Parece que hubo un problema interno en el servicio. Por favor, intenta nuevamente más tarde.',
}) => {
  return (
    <Result
      icon={<img style={{ maxWidth: 350 }} src="/assets/error.png" alt="403" />}
      title={title}
      subTitle={subTitle}
      extra={
        <Button type="primary" onClick={onClick}>
          Reintentar
        </Button>
      }
    />
  );
};

export default ErrorPage;
